module.exports = __webpack_public_path__ + "static/assets/greenpin.104a97a4.svg";